/* src/app/modules_v2/booking/locations/components/location-settings-form/location-settings-form.component.css */
.loading-overlay,
.saving-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.spinner-container {
  text-align: center;
}
.loading-text {
  margin-top: 16px;
  color: #666;
  font-size: 14px;
}
.saving-overlay {
  background: rgba(0, 0, 0, 0.7);
}
.saving-box {
  background: white;
  border-radius: 8px;
  padding: 32px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  text-align: center;
  min-width: 320px;
}
.saving-header {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #333;
}
.saving-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
.saving-body p {
  margin: 0;
  color: #666;
}
.location-settings-container {
  display: flex;
  height: calc(100vh - 180px);
  min-height: 600px;
  background: #f5f5f5;
}
.location-settings-sidebar {
  width: 280px;
  background: white;
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
.settings-nav {
  flex: 1;
  padding: 16px 0;
}
.nav-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
  -webkit-user-select: none;
  user-select: none;
}
.nav-item:hover {
  background: #f5f5f5;
}
.nav-item.active {
  background: #f9ffe0;
  border-left-color: var(--cf-brand-dark);
}
.nav-item.active .nav-label {
  color: var(--cf-brand-dark);
  font-weight: 600;
}
.nav-item.active .nav-icon {
  color: var(--cf-brand-dark);
}
.nav-item.completed {
  background: #f1f8e9;
}
.nav-item.has-errors {
  background: #ffebee;
}
.nav-item-content {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}
.nav-icon {
  color: #666;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.nav-label {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}
.nav-status {
  display: flex;
  align-items: center;
}
.status-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.status-icon.completed {
  color: #4caf50;
}
.status-icon.error {
  color: #f44336;
}
.progress-summary {
  padding: 16px 20px;
  border-top: 1px solid #e0e0e0;
  background: #fafafa;
}
.progress-text {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
  font-weight: 500;
}
.location-settings-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.settings-form {
  flex: 1;
  overflow-y: auto;
  padding: 32px;
  background: white;
}
.section-navigation {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 32px;
  background: white;
  border-top: 1px solid #e0e0e0;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
}
.section-indicator {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}
.section-navigation button {
  min-width: 120px;
}
.section-navigation button mat-icon {
  margin: 0 4px;
}
@media (max-width: 1200px) {
  .location-settings-sidebar {
    width: 240px;
  }
  .settings-form {
    padding: 24px;
  }
  .nav-label {
    font-size: 13px;
  }
}
@media (max-width: 768px) {
  .location-settings-container {
    flex-direction: column;
    height: auto;
  }
  .location-settings-sidebar {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #e0e0e0;
    max-height: 200px;
  }
  .settings-nav {
    display: flex;
    overflow-x: auto;
    padding: 8px;
  }
  .nav-item {
    flex-direction: column;
    min-width: 100px;
    padding: 12px 8px;
    text-align: center;
    border-left: none;
    border-bottom: 3px solid transparent;
  }
  .nav-item.active {
    border-left-color: transparent;
    border-bottom-color: var(--cf-brand-dark);
  }
  .nav-item-content {
    flex-direction: column;
    gap: 4px;
  }
  .nav-label {
    font-size: 11px;
    text-align: center;
  }
  .progress-summary {
    display: none;
  }
  .settings-form {
    padding: 16px;
    max-height: calc(100vh - 300px);
  }
  .section-navigation {
    padding: 12px 16px;
  }
  .section-indicator {
    display: none;
  }
}
.section-header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e0e0e0;
}
.section-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  gap: 12px;
}
.section-title mat-icon {
  color: var(--cf-brand-dark);
}
.section-description {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.5;
}
.section-content {
}
.field-block {
  background: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}
.field-block-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}
.field-block-title mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #666;
}
.fields-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}
.field-full-width {
  grid-column: 1 / -1;
}
.dynamic-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.dynamic-list-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
}
.list-item-card {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  transition: all 0.2s ease;
}
.list-item-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.list-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.list-item-actions {
  display: flex;
  gap: 8px;
}
.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #999;
}
.empty-state mat-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
  margin-bottom: 16px;
  opacity: 0.3;
}
.empty-state p {
  font-size: 14px;
  margin: 8px 0;
}
.location-form-shell {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.location-form-body {
  display: flex;
  flex: 1;
  gap: 0;
  transition: all 0.3s ease;
}
.location-form-content {
  flex: 1;
  min-width: 0;
  overflow-y: auto;
}
.preview-toggle-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px 4px;
  border-bottom: 1px solid #f0f0f0;
}
.preview-toggle-btn {
  font-size: 13px;
  height: 34px;
  line-height: 34px;
}
.preview-toggle-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  margin-right: 4px;
  vertical-align: middle;
}
.preview-open-btn {
  color: #666;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.location-preview-panel {
  width: 420px;
  flex-shrink: 0;
  border-left: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  background: #fff;
  position: sticky;
  top: 0;
  height: 100vh;
  max-height: 100vh;
}
.preview-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  background: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
  flex-shrink: 0;
}
.preview-panel-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  font-size: 13px;
  color: #444;
}
.preview-panel-title mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.preview-panel-actions {
  display: flex;
  align-items: center;
}
.preview-panel-body {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.preview-panel-iframe {
  width: 100%;
  flex: 1;
  border: none;
  display: block;
}
.preview-panel-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  color: #bbb;
  text-align: center;
  padding: 40px;
}
.preview-panel-empty mat-icon {
  font-size: 56px;
  width: 56px;
  height: 56px;
  margin-bottom: 12px;
  opacity: 0.25;
}
.preview-panel-empty p {
  font-size: 13px;
}
@media (max-width: 1100px) {
  .location-preview-panel {
    width: 360px;
  }
}
@media (max-width: 850px) {
  .location-form-body.preview-open {
    flex-direction: column;
  }
  .location-preview-panel {
    width: 100%;
    height: 450px;
    max-height: 450px;
    position: static;
    border-left: none;
    border-top: 1px solid #e0e0e0;
  }
}
.primary-sidebar {
  width: 4.5rem;
  background: var(--crm-sidebar);
  color: #cbd5e1;
  flex: 0 0 4.5rem;
}
.brand-mark {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.9rem;
  background: #3b82f6;
  color: #fff;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.125rem;
}
.icon-nav-link {
  width: 100%;
  color: #94a3b8;
  border-left: 3px solid transparent;
  border-radius: 0;
  padding: 1rem 0.75rem;
  display: flex;
  justify-content: center;
  transition:
    background-color .2s ease,
    color .2s ease,
    border-color .2s ease;
}
.icon-nav-link:hover {
  color: #fff;
  background: rgba(255, 255, 255, .06);
}
.icon-nav-link.active {
  color: #fff;
  background: rgba(255, 255, 255, .10);
  border-left-color: #60a5fa;
}
.main-shell {
  min-width: 0;
  flex: 1 1 auto;
  background: #fff;
  display: flex;
  flex-direction: column;
}
.topbar {
  height: 4rem;
  border-bottom: 1px solid var(--crm-border);
  flex-shrink: 0;
}
.top-tabs .nav-link {
  color: var(--crm-muted);
  border: 0;
  padding-inline: 0;
  margin-right: 1.5rem;
  height: 4rem;
  display: flex;
  align-items: center;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  font-weight: 500;
}
.top-tabs .nav-link.active {
  color: var(--crm-text);
  border-bottom-color: var(--crm-primary);
  background: transparent;
}
.content-shell {
  min-height: 0;
  flex: 1 1 auto;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
.section-nav {
  width: 16rem;
  flex: 0 0 16rem;
  border-right: 1px solid var(--crm-border);
  background: #f8fafc;
  overflow-y: auto;
}
.section-nav .nav-link {
  color: var(--crm-muted);
  border-radius: 0;
  padding: .8rem 1.5rem;
  border-right: 2px solid transparent;
  white-space: nowrap;
  font-weight: 500;
}
.section-nav .nav-link:hover {
  background: #f1f5f9;
  color: var(--crm-text);
}
.section-nav .nav-link.active {
  color: var(--crm-primary);
  background: #eff6ff;
  border-right-color: var(--crm-primary);
}
.tip-card {
  background: #eff6ff;
  color: #1d4ed8;
  border-radius: 1rem;
  font-size: .78rem;
  font-weight: 600;
  line-height: 1.5;
}
.form-pane {
  min-width: 0;
  flex: 1 1 auto;
  overflow-y: auto;
  background: #fff;
}
.form-wrap {
  max-width: 56rem;
}
.form-label {
  font-weight: 500;
  color: #334155;
}
.form-control,
.form-select {
  border-color: #cbd5e1;
  box-shadow: 0 1px 2px rgba(15, 23, 42, .04);
}
.form-control:focus,
.form-select:focus,
.form-check-input:focus {
  border-color: #60a5fa;
  box-shadow: 0 0 0 .25rem rgba(37, 99, 235, .15);
}
.badge-status {
  background: #dcfce7;
  color: #166534;
  font-weight: 600;
  padding: .45rem .75rem;
  border-radius: 999px;
}
.btn-primary {
  background-color: var(--crm-primary);
  border-color: var(--crm-primary);
}
.btn-primary:hover,
.btn-primary:focus {
  background-color: #1d4ed8;
  border-color: #1d4ed8;
}
.avatar-badge {
  width: 2rem;
  height: 2rem;
  background: #e2e8f0;
  color: #475569;
  font-weight: 700;
  font-size: .75rem;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.icon-btn {
  border: 0;
  background: transparent;
  padding: 0;
  color: #94a3b8;
}
.icon-btn:hover {
  color: #475569;
}
@media (max-width: 767.98px) {
  body {
    overflow: auto;
  }
  .app-shell {
    height: auto;
    min-height: 100vh;
  }
  .main-shell {
    min-height: 100vh;
  }
  .content-shell {
    flex-direction: column;
    overflow: visible;
  }
  .section-nav {
    width: 100%;
    flex: 0 0 auto;
    border-right: 0;
    border-bottom: 1px solid var(--crm-border);
  }
  .section-nav .nav {
    flex-wrap: nowrap;
    overflow-x: auto;
    white-space: nowrap;
  }
  .section-nav .nav-link {
    border-right: 0;
    border-bottom: 2px solid transparent;
  }
  .section-nav .nav-link.active {
    border-bottom-color: var(--crm-primary);
  }
  .top-tabs {
    display: none;
  }
}
/*# sourceMappingURL=location-settings-form.component.css.map */
